import HexCheckBox from './src/index.vue'

HexCheckBox.install = function (Vue) {
  Vue.component(HexCheckBox.name, HexCheckBox)
}
export default HexCheckBox



// WEBPACK FOOTER //
// ./packages/components/checkbox/index.js